import React, { useEffect, useRef, useState } from "react";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CustomeStyle } from "../Css/CustomeStyle";
import Footer from "../Fotter";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { viewCartData } from "../redux/slices/ViewCartSlice";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { FiShoppingCart } from "react-icons/fi";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import { AiOutlineArrowLeft } from "react-icons/ai";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";

function ShowBrandData() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [likedProducts, setLikedProducts] = useState(new Set());
  const { id } = useParams();
  const [showAllBrand, setShowAllBrand] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBrandData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${endPoint.GetBrandById}?brand=${id}`
        );
        setShowAllBrand(response?.data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching brand data:", error.message);
      }
    };

    fetchBrandData();
  }, [dispatch, id]);

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };

    dispatch(AddToCart(cartData))
      .then(() => {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  };

  const ProductCard = ({
    item,
    toggleLike,
    likedProducts,
    handleAddToCart,
    CustomeStyle,
  }) => {
    return (
      <div
        key={item._id}
        className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 sm:px-5 sm:py-2 px-4 py-2"
      >
        {" "}
        <img
          src={item?.images[0]}
          alt={item.name}
          className="w-full h-20 sm:h-40 object-contain bg-light"
        />
        <button
          className="like-btn absolute top-2 left-2"
          onClick={() => toggleLike(item._id)}
        >
          {likedProducts.has(item._id) ? (
            <FaHeart size="24px" className="text-red-500 sm:text-lg text-xs" />
          ) : (
            <FaRegHeart
              size="24px"
              className="text-gray-400 sm:text-lg md:text-xs"
            />
          )}
        </button>
        <button
          onClick={() => handleAddToCart(item)}
          className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
        >
          <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
        </button>
        <Link
          to={`/category/${item?.category ? generateSlug(item?.category) : "-"
            }/${generateSlug(item?.title)}/${generateSlug(item?._id)}`}
          state={{ item }}
          className="block"
        >
          <div>
            <h2 className="sm:text-xl text-xs text-black sm:mt-0 mt-3">
              {item.name}
            </h2>
            <h2
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              className={CustomeStyle.title}
            >
              {item.title}
            </h2>
            <div>
              <span className={CustomeStyle.description}>
                {item.description}
              </span>
            </div>
            <div className="mt-2 flex justify-between items-center me-2">
              <div className={`${CustomeStyle.row} space-x-1`}>
                <span className={CustomeStyle.text}>₹{item.salePrice}</span>
                <span
                  className={CustomeStyle.text}
                  style={{ textDecoration: "line-through" }}
                >
                  ₹{item.regularPrice}
                </span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);
    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-16647750621');
      `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex mx-auto  items-center  w-[90%] mt-24 ">
        <button
          onClick={() => navigate(-1)}
          className="mr-2 bg-gray-200 px-2 py-2  rounded-full flex items-center"
        >
          <AiOutlineArrowLeft className="text-lg mr-1" />
        </button>
        <h2 className="text-xl font-bold  sm:px-5 sm:p-3 p-0 px-6 mt-3 sm:mt-20">
          {id}
        </h2>
      </div>

      <div className="w-[90%] mx-auto flex flex-col md:flex-row gap-8 justify-center  mb-[3%] ">
        <div className="w-full sm:w-[95%] md:w-[100%] mt-0 ">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-1 lg:gap-3">
            {/* {showAllBrand?.length > 0 ? (
              showAllBrand?.map((item) => (
                <ProductCard
                  key={item._id}
                  item={item}
                  toggleLike={toggleLike}
                  likedProducts={likedProducts}
                  handleAddToCart={handleAddToCart}
                  CustomeStyle={CustomeStyle}
                />
              ))
            ) : (
              <div className="flex justify-center items-center h-[200px] w-full sm:ms-96 ms-20">
                <p className="text-center text-lg font-semibold">
                  No Product Found
                </p>
              </div>
            )} */}
            {loading ? (
              <div className="flex justify-center items-center h-[200px] w-full">
                <p className="text-center text-lg font-semibold">Loading...</p>
              </div>
            ) : showAllBrand?.length > 0 ? (
              showAllBrand.map((item) => (
                <ProductCard
                  key={item._id}
                  item={item}
                  toggleLike={toggleLike}
                  likedProducts={likedProducts}
                  handleAddToCart={handleAddToCart}
                  CustomeStyle={CustomeStyle}
                />
              ))
            ) : (
              <div className="flex justify-center items-center h-[200px] w-full sm:ms-96 ms-20">
                <p className="text-center text-lg font-semibold">
                  No Product Found
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ShowBrandData;
